export const name = "DETERMINISTIC_DECRYPT_STRING";
export const summary = `Uses the matching key from a keyset to decrypt a \`BYTES\` ciphertext into a \`STRING\` plaintext, using deterministic AEAD.`;
export const reference = `
## DETERMINISTIC_DECRYPT_STRING

Uses the matching key from a keyset to decrypt a \`BYTES\` ciphertext into a \`STRING\` plaintext, using deterministic AEAD.

\`\`\`
DETERMINISTIC_DECRYPT_STRING(keyset, ciphertext, additional_data)
\`\`\`

### Description

Like \`DETERMINISTIC_DECRYPT_BYTES\`, but where\`plaintext\` is of type \`STRING\`.


### Return Data Type

\`STRING\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
`;
